import { TREATMENT, TREATMENT_A, TREATMENT_B, DEFAULT } from '../Services/Analytics/TrackEventsService';
import { LocalStorage } from '../Common/Utils/local_storage';

const proExperimentsNamespace = (proUuid) => `experiments_${proUuid}`;

const getDataInLocalStorage = (proUuid) => LocalStorage.getItem(proExperimentsNamespace(proUuid)) || {};

export const getValueFromLocalStorage = (proUuid, key) => {
  const data = getDataInLocalStorage(proUuid);
  return data[key];
};

export const setValueInLocalStorage = (proUuid, key, value) => {
  const data = getDataInLocalStorage(proUuid);
  data[key] = value;
  LocalStorage.setItem(proExperimentsNamespace(proUuid), data);
};

const TRACKED_VARIATIONS = [TREATMENT, TREATMENT_A, TREATMENT_B, DEFAULT];

export const isTrackableVariation = (variation) => TRACKED_VARIATIONS.includes(variation);

const formatExperimentString = (featureFlag, variant) => `${featureFlag}=${variant}`;

const EXPERIMENT_FLAGS = [];

export const formattedFlags = (ldFeatureFlags) =>
  Object.keys(ldFeatureFlags)
    .filter((featureFlag) => EXPERIMENT_FLAGS.includes(featureFlag))
    .map((featureFlag) => formatExperimentString(featureFlag, ldFeatureFlags[featureFlag]));
